import { render, staticRenderFns } from "./mobMenu.vue?vue&type=template&id=edf7810c&scoped=true"
import script from "./mobMenu.vue?vue&type=script&lang=js"
export * from "./mobMenu.vue?vue&type=script&lang=js"
import style0 from "./mobMenu.vue?vue&type=style&index=0&id=edf7810c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf7810c",
  null
  
)

export default component.exports